import Breadcrumb from "../../Component/Breadcrumb";

function Moto() {
  return (
    <>
      <Breadcrumb>About / Moto</Breadcrumb>
      <div className="innersec ">
        <div className="container">
          <div className="col-lg-12">
            <h1>School Motto</h1>
          </div>
          <div className="col-lg-12">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/logo_icon.JPG"
              className="logo_moto_img"
            />
          </div>

          <div className="row align-items-center image_Content_moto">
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 text-center text-lg-start">
              <h2 className="moto_heading">
                “Lead Kindly Light through the Values of Love, Justice &
                Service”
              </h2>
              {/* <p className="moto_description">
                At St. Joseph’s School, our motto reflects our commitment to
                guiding every student towards wisdom, compassion, and
                excellence. We aim to enlighten minds and hearts with the light
                of truth and service.
              </p> */}
            </div>

            <div className="col-lg-6 col-md-12 text-center">
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/slider1.png"
                alt="School Building"
                className="school_bld_img shadow-lg rounded-4"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Moto;
